import { Set } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'app/redux/types';

import { StakeType } from 'app/lib/staking/constants';

import { RecordOfStakeTypeAmountType } from '../records';
import { AvailableStakeType, CheckedStakeType } from '../types/stakeTypes';
import { selectStakeTypesState } from './state';

// ---

export const selectAvailableStakeTypes = (state: ReduxState): AvailableStakeType => {
  return selectStakeTypesState(state).available;
};

export const selectCheckedStakeType = (state: ReduxState): CheckedStakeType => {
  return selectStakeTypesState(state).checked;
};

export const selectAmountStakeType = (state: ReduxState): RecordOfStakeTypeAmountType => {
  return selectStakeTypesState(state).amount;
};

const setOfSingle = Set.of(StakeType.SINGLE);
const setOfExpress = Set.of(StakeType.EXPRESS);

export const selectCurrentStakeType = createSelector(
  selectAvailableStakeTypes,
  selectCheckedStakeType,
  (available, checked) => {
    if ((available.size === 1 && available.has(StakeType.SINGLE)) || checked === StakeType.SINGLE) {
      return setOfSingle;
    }

    const combinationAvailable = available.remove(StakeType.SINGLE);

    if (combinationAvailable.size === 1 && combinationAvailable.has(StakeType.EXPRESS)) {
      return setOfExpress;
    }

    const checkedType = available.get(checked);

    if (checkedType) {
      return Set.of(checkedType);
    }

    return setOfSingle;
  },
);
